export { Grid } from "@mantine/core";
export type { GridProps } from "@mantine/core";
